export default __webpack_public_path__ + "static/media/icon-menu-claim.ea7290ff.svg";